import Vuex from 'vuex'
import Vue from 'vue'
Vue.use(Vuex)

import moduloUsuario from './usuarios/usuario'
import moduloUsuarios from './usuarios/usuarios'
import moduloPacientes from './pacientes/pacientes'
import moduloPropietarios from './propietarios/propietarios'
import moduloEmpleados from './empleados/empleados'
import moduloCorporativos from './corporativo/corporativo'
import moduloFranquicias from './franquicias/franquicias'
//import moduloIndicePacientes from './pacientes/indicePacientes'
import moduloEspecies from './Especies/especies'
import moduloProductos from './productos/productos'
import moduloServicios from './servicios/servicios'
import moduloPlanesBienestar from './planes_bienestar/planes_bienestar'
import moduloPlanBienestar from './planes_bienestar/plan_bienestar'
import moduloEstudios from './estudios/estudios'
import moduloCasos from './casos/casos'
import moduloEspacios from './espacios/espacios'
import moduloAgenda from './agenda/agenda'
import moduloCorteCajas from './cajas/cortes_caja'
import moduloCajas from './cajas/cajas'
import moduloSaldo from './saldo/saldo'
import moduloSaldoNuevo from './saldo/index'
import moduloDescuentos from './descuentos/descuentos'
import moduloReportes from './reportes/reportes'
import moduloRoles from './roles/roles'
import moduloPanelRoles from './panel_roles/panel_roles'
import moduloNotificaciones from './notificaciones/notificaciones'
import moduloColores from './colores/colores'
import moduloFormatos from './formatos/formatos'
import moduloVencimientos from './vencimientos/vencimientos'
import moduloAlmacenes from './almacenes'
import moduloCompras from './compras'
import moduloProveedores from './proveedores'
import moduloUnidades from './unidades'
import moduloInventarios from './inventarios'
import moduloVentaMostrador from './venta_mostrador'
import moduloGastos from './gastos'
import moduloCategorias from './categorias'

/*export default new Vuex.Store({
    modules:[moduloUsuario,moduloUsuarios,moduloPacientes,moduloPropietarios,moduloCorporativos]
})*/

export default new Vuex.Store({
  modules: [
    moduloUsuario,
    moduloUsuarios,
    moduloPacientes,
    moduloPropietarios,
    moduloEmpleados,
    moduloCorporativos,
    moduloFranquicias,
    moduloPlanesBienestar,
    moduloPlanBienestar,
    //moduloIndicePacientes,
    moduloEspecies,
    moduloProductos,
    moduloServicios,
    moduloEstudios,
    moduloCasos,
    moduloEspacios,
    moduloAgenda,
    moduloCorteCajas,
    moduloCajas,
    moduloSaldo,
    moduloSaldoNuevo,
    moduloDescuentos,
    moduloReportes,
    moduloRoles,
    moduloPanelRoles,
    moduloNotificaciones,
    moduloColores,
    moduloFormatos,
    moduloVencimientos,
    moduloAlmacenes,
    moduloProveedores,
    moduloUnidades,
    moduloCompras,
    moduloInventarios,
    moduloVentaMostrador,
    moduloGastos,
    moduloCategorias,
  ]
})



// WEBPACK FOOTER //
// ./src/store/index.js